import API from '../shared/intersection.axios';
import config from '../config.json'
import {showError, showSuccess} from '../shared/notify.component';

const state = () => {
    return {
        projectExport: []
    };
};

// getters
const getters = {
    getProjectExport(state) {
        return state.projectExport
    }
};

// actions
const actions = {

    loadExportHistory({commit, dispatch}, data) {
        return API.get(config.endpoints.planExportHistory + '?id=' + data.id).then(response => {
            return response.data.result
        })
            .catch((error) => {
                showError(error.response.data.message, this._vm.$toast)
                dispatch('shared/setLoading', false, {root: true})
            });
    },
    planPdfGenerate({commit, dispatch}, planId) {

        dispatch('shared/setLoading', true, {root: true})

        return API.get(config.endpoints.planPdfGenerate + '?id=' + planId,).then(response => {
            dispatch('shared/setLoading', false, {root: true})
            return response
        })
            .catch((error) => {
                showError(error.response.data.message, this._vm.$toast)
                dispatch('shared/setLoading', false, {root: true})
            });


    },
    loadPlanPdf({commit, dispatch}, data) {

        dispatch('shared/setLoading', true, {root: true})

        return API.get(config.endpoints.planExport + '?id=' + data.id, {tempToken: data.token}).then(response => {

            commit('setPlan', response.data.result.data)
            dispatch('shared/setLoading', false, {root: true})
            return response
        })
            .catch((error) => {
                showError(error.response.data.message, this._vm.$toast)
                dispatch('shared/setLoading', false, {root: true})
            });
    },

    loadPlanExport({commit, dispatch}, data) {

        dispatch('shared/setLoading', true, {root: true})

        return API.get(config.endpoints.planExport + '?id=' + data.id + '&lang=' + data.lang).then(response => {

            commit('setPlan', response.data.result.data)
            dispatch('shared/setLoading', false, {root: true})
            return response
        })
            .catch((error) => {
                showError(error.response.data.message, this._vm.$toast)
                dispatch('shared/setLoading', false, {root: true})
            });
    },

    resetProjectExport({commit}) {
        commit('setPlan', [])
    }
};

// mutations
const mutations = {
    setPlan(state, data) {
        state.projectExport = data
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
